import { get } from 'lodash';

export const selectFormOptions = state => get(state, ['formOptions'], {});
export const selectIssueTypes = state => selectFormOptions(state).types;

export const selectPropertiesCatalog = state => selectFormOptions(state).propertiesCatalog.map( item => ({ value: item.id, 
    label: item.name + ((item.makeName || item.model) ? ' - ' + item.makeName + ' ' + item.model : '')}))
  
